import apiClient from './client';

export interface NotificationItem {
  id: string;
  event: string;
  title: string;
  body: string;
  entityType: string;
  entityId: string;
  metadata: Record<string, any>;
  read: boolean;
  readAt: string | null;
  createdAt: string;
}

export const notificationsApi = {
  list: (params?: { read?: boolean; limit?: number; cursor?: string }) =>
    apiClient.get<{
      data: NotificationItem[];
      pagination: { limit: number; nextCursor: string | null };
    }>('/notifications', { params }),

  unreadCount: () => apiClient.get<{ count: number }>('/notifications/unread-count'),

  markAsRead: (id: string) => apiClient.patch(`/notifications/${id}/read`),

  markAllAsRead: () => apiClient.patch('/notifications/read-all'),

  getPreferences: () =>
    apiClient.get<{ mutedEvents: string[]; soundEnabled: boolean }>('/notifications/preferences'),

  updatePreferences: (data: { mutedEvents?: string[]; soundEnabled?: boolean }) =>
    apiClient.patch<{ mutedEvents: string[]; soundEnabled: boolean }>(
      '/notifications/preferences',
      data,
    ),
};
